var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-wrap",on:{"click":_vm.toggleSelected}},[(_vm.isSelected)?_c('Icon',{staticClass:"icon-checkbox",attrs:{"img":_vm.selectedImg}}):_c('span',{staticClass:"icon-checkbox icon-checkbox-empty"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63d37a1b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kubaolottery/ModalCheckboxButton.vue
// module id = null
// module chunks = 